import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function AuditNotificationsButton({ compact = false, unreadCount = 0, isRecipient = false }) {
  const [open, setOpen] = useState(false);

  if (!isRecipient) return null;

  return (
    <div className="relative">
      <button
        type="button"
        aria-label="Alertas de auditoría"
        onClick={() => setOpen((v) => !v)}
        className={`relative flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-sm text-gray-700 hover:bg-gray-50 ${
          compact ? 'w-9 h-9' : 'w-11 h-11'
        }`}
      >
        <span aria-hidden>🔔</span>
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-64 bg-white border rounded-lg shadow-lg z-50 p-3 text-sm">
          <p className="font-medium text-gray-800 mb-2">Alertas de auditoría</p>
          <p className="text-gray-600 mb-3">
            {unreadCount > 0 ? `${unreadCount} sin leer` : 'Sin alertas nuevas'}
          </p>
          <Link
            to="/audit/kardex"
            className="block text-teal-600 hover:underline mb-1"
            onClick={() => setOpen(false)}
          >
            Ver eventos de auditoría
          </Link>
          <Link
            to="/audit/my-inventory-counts"
            className="block text-teal-600 hover:underline"
            onClick={() => setOpen(false)}
          >
            Mis tomas de inventario
          </Link>
        </div>
      )}
    </div>
  );
}
